import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import OperationHours from '../OperationHours';
import { formatPhoneNumber, rxRoute } from "../../../helpers/formatting";
import * as d from "../../../reducers/domainReducer";

class OrderRefillSuccess extends React.Component {
    constructor(props) {
        super(props);
    }

    getDrugInfo(rxNumber) {
        const drugInfo = this.props.getDrugInfo(rxNumber);
        if (!drugInfo.ndcImageURL || drugInfo.ndcImageURL === "")
            drugInfo.ndcImageURL = '/images/prescription_placeholder.jpg';
        return drugInfo;
    }

    render() {
        const { successfullRefills, renewedRefills, pharmacyDetails, hasPharmacyLogin, currentPharmacyUser, addressUrl, proxyUser } = this.props;

        const successfulOrRenewedRefills = ((successfullRefills && successfullRefills.Prescriptions.length > 0) || (renewedRefills && renewedRefills.Prescriptions.length > 0));

        if (!successfulOrRenewedRefills || !pharmacyDetails) return null;

        const pickupTime = successfullRefills && successfullRefills.Message;
        const phoneNumber = formatPhoneNumber(pharmacyDetails.PhoneNumber);
        let prefix = '/';

        if (typeof window !== 'undefined' && window.serverData.data.bundle !== 'pharmacy' && window.location.href.toLowerCase().indexOf('localhost') > -1) {
            prefix = '/pharmacy';
        }

        const isPrimaryPharmacyUser = hasPharmacyLogin && (!currentPharmacyUser || !currentPharmacyUser.pharmacyPatientId);
        const message = (isPrimaryPharmacyUser ? "Set up notifications to be alerted when your prescriptions are ready." : "Set up notifications to be alerted when " + currentPharmacyUser.firstName + "'s prescriptions are ready.");

        return (
            <React.Fragment>
                <div className="col-12 col-lg-8 confirm-rx-list-container">
                    {successfullRefills && successfullRefills.Prescriptions.length > 0 &&
                        <div className="confirm-rx-list">
                            {successfullRefills.Prescriptions.map((item) => {
                                const drugInfo = this.getDrugInfo(item.RxNumber);
                                return (
                                    <div key={item.RxNumber} className="confirm-rx-list__item">
                                        <div className="rx-img-container">
                                            <div className="confirm-rx-list__img">
                                                <img src={drugInfo.ndcImageURL} alt={drugInfo.drugName + " photo"} className="img-responsive" />
                                            </div>
                                        </div>
                                        <div className="confirm-rx-list__info">
                                            <div>{drugInfo.drugName}</div>
                                            <div>RX No. {item.RxNumber}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    }
                    {renewedRefills && renewedRefills.Prescriptions.length > 0 &&
                        <div className="confirm-rx-list">
                            {renewedRefills.Prescriptions.map((item) => {
                                const drugInfo = this.getDrugInfo(item.RxNumber);
                                return (
                                    <div key={item.RxNumber} className="confirm-rx-list__item">
                                        <div className="rx-img-container">
                                            <div className="confirm-rx-list__img">
                                                <img src={drugInfo.ndcImageURL} alt={drugInfo.drugName + " photo"} className="img-responsive" />
                                            </div>
                                        </div>
                                        <div className="confirm-rx-list__info">
                                            <div>{drugInfo.drugName}</div>
                                            <div>RX No. {item.RxNumber}</div>
                                        </div>
                                    </div>
                                );
                            })}
                            {renewedRefills.Message &&
                                <div className="rx-confirmation-status-msg successful-rx details-icon-prepend">
                                    <div className="icon-col">
                                        <span className="icon-info-filled" />
                                    </div>
                                    <div className="details-col">
                                        {renewedRefills.Message}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>

                {successfulOrRenewedRefills &&
                    <div className="col-12 col-lg-4 confirm-addl-details-container">
                        <div className="confirm-addl-details-info">
                            <div className="row">
                                <div className="col-12 confirm-refill-time">
                                    <h2 className="h5">Pick Up Time:</h2>
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-calendar-form" />
                                        </div>
                                        <div className="details-col">
                                            <div>{pickupTime ? pickupTime.substr(0, pickupTime.indexOf("at ") + 2) : ''}</div>
                                            <div className="confirm-time-size">{pickupTime ? pickupTime.substring(pickupTime.indexOf("at ") + 2, pickupTime.length) : ''}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 confirm-pickup-location">
                                    <h2 className="h5">Pick Up Location:</h2>
                                    <a className={addressUrl ? "directions-link" : "no-link"} href={addressUrl} target="_blank">
                                        <div className="details-icon-prepend">
                                            <div className="icon-col">
                                                <span className="icon-address" />
                                            </div>
                                            <div className="details-col">
                                                {pharmacyDetails.Name ?
                                                    <div>{pharmacyDetails.Name}</div>
                                                    : <div className="no-data-dash">
                                                        <div />
                                                    </div>}
                                                {pharmacyDetails.Address ?
                                                    <div>
                                                        <div>{pharmacyDetails.Address.StreetAddress} </div>
                                                        <div>{pharmacyDetails.Address.City}, {pharmacyDetails.Address.State} {pharmacyDetails.Address.Zip} </div>
                                                    </div>
                                                    : <div className="no-data-dash">
                                                        <div />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </a>

                                    <a className={phoneNumber ? "phone-link" : "no-link"} href={phoneNumber ? "tel:" + (phoneNumber) : "#"}>
                                        <div className="details-icon-prepend">
                                            <div className="icon-col">
                                                <span className="icon-phone" />
                                            </div>
                                            <div className="details-col">
                                                {phoneNumber ?
                                                    <div>{phoneNumber}</div>
                                                    : <div className="no-data-dash">
                                                        <div />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </a>

                                    <div className="operating-hours">
                                        <div className="details-icon-prepend">
                                            <div className="icon-col">
                                                <span className="icon-clock" />
                                            </div>
                                            {pharmacyDetails.OperationHours ?
                                                <div className="details-col">
                                                    {pharmacyDetails.OperationHours.OperationTimings.map((item, index) =>
                                                        (<div className="addtlHours" key={index}>
                                                            <div>
                                                                <span className="hours-day">{item.Days}</span>
                                                                <span className="hours-time">{item.Hours} </span>
                                                            </div>
                                                        </div>)
                                                    )}
                                                </div> :
                                                <div className="details-col">
                                                    <div className="no-data-dash">
                                                        <div />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {pharmacyDetails.IsDefault &&
                                        <div className="your-pharmacy-label">
                                            <div className="details-icon-prepend">
                                                <div className="icon-col">
                                                    <span className="icon-find-pharmacy" />
                                                </div>
                                                <div className="details-col">Your Pharmacy</div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* isPrimaryPharmacyUser && */
                    <div className="col-12 col-lg-8">
                        <div className="rx-notification-container">
                            <div className="row align-items-center">
                                <div className="col-12 successRX-msg">
                                    {message}
                                </div>
                                {!proxyUser && <div className="col-12 successRX-btn">
                                    <Link to="/notifications">
                                        MANAGE NOTIFICATIONS<span className="icon-arrow-rt" />
                                    </Link>
                                </div>}
                            </div>
                        </div>
                    </div>
                }

                <div className="col-12">
                    <Link to={{ pathname: prefix === '/' ? '/rxHome' : '/pharmacy' }} className="btn btn-primary">PHARMACY HOME</Link>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

export default connect(mapStateToProps, null)(OrderRefillSuccess);